import { IoChevronForward } from "react-icons/io5";
import { Link } from "react-router-dom";

const items = [
  {
    title: "Certificate of Registrations",
    description: "Summary of Certificate of Registrations",
    url: "/certificate-of-registrations",
  },
  {
    title: "Unposted Entries",
    description: "Official Receipts, 2307, and Payments",
    url: "/unposted-entries",
  },
  {
    title: "Account RDOs",
    description: "Accounts with their respective RDOs",
    url: "/account-rdos",
  },
  {
    title: "Creditable Withholding Tax",
    description: "Uploaded 2307s",
    url: "/creditables",
  },
  {
    title: "Official Receipts",
    description: "Uploaded Receipts",
    url: "/receipts",
  },
];

const DashboardNavigation = () => {
  return (
    <div className="card p-0">
      {items.map(({ title, description, url }, index) => (
        <div
          className="px-8 py-4 cursor-pointer hover:bg-gray-50 border-b last:border-b-0"
          key={index}
        >
          <Link className="flex items-center justify-between" to={url}>
            <div>
              <p className="text-gray-500 text-sm">{title}</p>
              <span className="text-sm text-gray-400">{description}</span>
            </div>
            <IoChevronForward className="text-blue-500" />
          </Link>
        </div>
      ))}
    </div>
  );
};

export default DashboardNavigation;
